<div class="aza-activities-cart aza-vertical-stack">
  <div class="aza-activities-cart-list-container">
    @if (eventSettings) {
      <aza-rws-activities-cart-list [eventSettings]="eventSettings"
        [searchTextChanged]="searchTextChanged" [showActivitiesCart]="showActivitiesCart"
        [activitiesCartFilterSubject]="activitiesCartFilterSubject" [activitiesCartFilterItemId]="selectedDisplayFilterItemId"
        [displayType]="activitiesCartDisplayType" [locked]="locked" [showAddToCalendar]="showAddToCalendar"
        [hideAvailablePlacesLeft]="hideAvailablePlacesLeft"
        (activitiesChanged)="onActivitiesChanged($event)">
      </aza-rws-activities-cart-list>
    }
  </div>
</div>
